module.exports = __webpack_public_path__ + "static/media/skull_1f480.a7550692.png";